// import * as yup from "yup";

export const validateOptionYup = {
  abortEarly: false,
};

export const validateData = async (Schema, formData, setErrors) => {
  try {
    await Schema.validate(formData, validateOptionYup);
    return true;
  } catch (error) {
    const newErrors = {};
    error?.inner?.forEach((error) => {
      newErrors[error.path] = { message: error.message };
    });
    setErrors(newErrors);
    console.log(error, "validation error", newErrors);
    return false;
  }
};

export const clearError = (setErrors, key) =>
  setErrors((prev) => {
    const updated = { ...prev };
    delete updated[key];
    return updated;
});